module.exports = __webpack_public_path__ + "img/web-front-end-future-title.9bde79c7.png";